function ctUpdateCartSections(cart, response) {
  if (!cart || !response.sections) return;
  if (cart.getSectionsToRender && cart.getSectionInnerHTML) {
    cart.getSectionsToRender().forEach(function (section) {
      var el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (el && response.sections[section.id]) {
        el.innerHTML = cart.getSectionInnerHTML(response.sections[section.id], section.selector);
      }
    });
  }
  var drawerInner = cart.querySelector ? cart.querySelector('.drawer__inner') : null;
  if (drawerInner) drawerInner.classList.remove('is-empty');
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          
          if (response.status) {
            
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                ctUpdateCartSections(this.cart, response);
                document.dispatchEvent(new CustomEvent('ct:atc-success', {
                  detail: { variantId: formData.get('id'), imageUrl: response.featured_image ? response.featured_image.url : '' }
                }));
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {

            
            
            var $this=this;
            ctUpdateCartSections($this.cart, response);
            document.dispatchEvent(new CustomEvent('ct:atc-success', {
              detail: { variantId: formData.get('id'), imageUrl: response.featured_image ? response.featured_image.url : '' }
            }));
            // Gift add/removal is handled centrally by the global cart-mutation
            // hook in ct-atc-flow.js, which already sees this /cart/add.js request.
            
               
           
          }

         


          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    this.submitButton.classList.remove('loading');
                    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
